import React from 'react';

type DetailModeSwitchProps = {
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
};

export const DetailModeSwitch: React.FC<DetailModeSwitchProps> = ({
  checked,
  onChange,
  disabled = false,
}) => {
  return (
    <label className="inline-flex items-center gap-3 cursor-pointer">
      <span className={`text-sm font-medium ${checked ? 'text-orange-600' : 'text-gray-600'}`}>
        {checked ? 'Ocultar detalle' : 'Mostrar detalle'}
      </span>
      <button
        type="button"
        role="switch"
        aria-checked={checked}
        disabled={disabled}
        onClick={onChange}
        className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 ${
          checked ? 'bg-orange-500' : 'bg-gray-300'
        }`}
      >
        <span
          className={`inline-block h-4 w-4 transform rounded-full bg-white shadow-md transition-transform ${
            checked ? 'translate-x-6' : 'translate-x-1'
          }`}
        />
      </button>
    </label>
  );
};

export default DetailModeSwitch;
